import { render, staticRenderFns } from "./StepVerdictButton.vue?vue&type=template&id=71fae445&scoped=true"
import script from "./StepVerdictButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StepVerdictButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StepVerdictButton.vue?vue&type=style&index=0&id=71fae445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fae445",
  null
  
)

export default component.exports